import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { styled } from '@mui/material/styles';

import {
  Grid,
  Paper,
  TextField,
  Box,
  Stack,
  Skeleton,
  Button,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormHelperText,
  FormGroup,
  Checkbox,
  Chip,
} from '@mui/material';
import 'dayjs/locale/ko'; 

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';

import * as dayjs from 'dayjs'
import { useDispatch, useSelector } from 'react-redux';
import HrGradeSelectbox from '../common/form/selectbox/HrGradeSelectbox';
import HrPolicySelectbox from '../common/form/selectbox/HrPolicySelectbox';
import HrDptSelectbox from '../common/form/selectbox/HrDptSelectbox';
import EmpFileUploadContainer from '../../containers/common/fileupload/EmpFileUploadContainer';
import useProfileImage from '../../hooks/useProfileImage';
import { getBaseCodes } from '../../modules/auth';

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const authFilter = {
  blcCd: 'AUTH',
  mlcCd: 'USR',
  useYn: 'Y',
};

const EmployeeForm = ({ employee, formik }) => {
  const [entryDt, setEntryDt] = useState(
    formik?.values?.entryDt ? dayjs(formik.values.entryDt) : null,
  );
  const dispatch = useDispatch();
  const baseCodes = useSelector(({ auth }) => auth.baseCodes);
  const authCodeList = _.orderBy(
    _.filter(baseCodes || [], authFilter),
    'step',
  ).filter((item) => item?.revVal1 && String(item.revVal1).trim());

  useEffect(() => {
    if (!baseCodes) {
      dispatch(getBaseCodes());
    }
  }, [baseCodes, dispatch]);

  useEffect(() => {
    if (formik?.values?.entryDt) {
      setEntryDt(dayjs(formik.values.entryDt));
    }
  }, [formik?.values?.entryDt]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  const handleChangePrivilege = (item, isCheck) => {
    const old_list = [...formik.values.privilegeList];

    const newValue = {
      tgtUuid: employee?.usrUuid,
      tgtTyp: item?.slcCd,
      authTyp: item?.revVal2,
      authNm: item?.revVal1,
      authYn: isCheck ? 'Y' : 'N',
    };
    // 기존에 있는가? 있으면 업데이트, 없으면 추가.
    const findIndex = _.findIndex(
      old_list,
      (ol) => ol.authTyp === newValue?.authTyp,
    );
    console.log(findIndex, 'findIndex');
    if (findIndex > -1) {
      old_list[findIndex] = { ...old_list[findIndex], ...newValue };
    } else {
      old_list.push(newValue);
    }

    formik.setFieldValue('privilegeList', old_list);

    console.log(old_list, 'old_list');
  };

  // 프로필 이미지 URL (axios를 통해 인증 토큰과 함께 로드)
  const profileImageSrc = useProfileImage(employee?.usrUuid, employee?.profileImg);

  return (
    <>
      <Paper
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 1,
          p: 2,
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Grid container spacing={1}>
          {employee && (
            <Grid xs={3} item textAlign="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignContent: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mb: 1,
                }}
              >
                {profileImageSrc ? (
                  <Img
                    style={{
                      width: 200,
                      height: 170,
                    }}
                    alt={employee.usrNm}
                    src={profileImageSrc}
                  />
                ) : (
                  <Skeleton
                    variant="rectangular"
                    width={200}
                    height={170}
                    animation={false}
                  />
                )}
              </Box>
              {/* <FileDropZone fileTyp="profile" fileAttrVal1={user.usrUuid} /> */}
              <EmpFileUploadContainer
                fileTyp="profile"
                fileAttrVal1={employee.usrUuid}
              />
            </Grid>
          )}
          <Grid
            item
            xs={employee ? 9 : 12}
            sx={{ flexGrow: 1 }}
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={2}>
                <TextField
                  margin="normal"
                  required
                  variant="outlined"
                  fullWidth
                  id="usrNo"
                  name="usrNo"
                  label="사번"
                  value={formik.values.usrNo}
                  onChange={formik.handleChange}
                  error={formik.touched.usrNo && Boolean(formik.errors.usrNo)}
                  helperText={formik.touched.usrNo && formik.errors.usrNo}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  margin="normal"
                  required
                  variant="outlined"
                  fullWidth
                  id="usrNm"
                  name="usrNm"
                  label="이름"
                  value={formik.values.usrNm}
                  onChange={formik.handleChange}
                  error={formik.touched.usrNm && Boolean(formik.errors.usrNm)}
                  helperText={formik.touched.usrNm && formik.errors.usrNm}
                />
              </Grid>
              <Grid item xs={4}>
                <HrDptSelectbox
                  formik={formik}
                  name="dptUuid"
                  label="부서"
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={3}>
                <HrGradeSelectbox
                  formik={formik}
                  name="gradeUuid"
                  label="직급"
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            {!employee && (
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={1}
              >
                <Grid item xs={6}>
                  <TextField
                    type="password"
                    margin="normal"
                    required
                    variant="outlined"
                    fullWidth
                    autoComplete="current-password"
                    id="password"
                    name="password"
                    label="비밀번호"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.password && Boolean(formik.errors.password)
                    }
                    helperText={
                      formik.touched.password && formik.errors.password
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    type="password"
                    margin="normal"
                    required
                    variant="outlined"
                    fullWidth
                    autoComplete="current-confirmPassword"
                    id="confirmPassword"
                    name="confirmPassword"
                    label="비밀번호 확인"
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.confirmPassword &&
                      Boolean(formik.errors.confirmPassword)
                    }
                    helperText={
                      formik.touched.confirmPassword &&
                      formik.errors.confirmPassword
                    }
                  />
                </Grid>
              </Grid>
            )}
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={3}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="telNo"
                  name="telNo"
                  label="연락처"
                  value={formik.values.telNo}
                  onChange={formik.handleChange}
                  error={formik.touched.telNo && Boolean(formik.errors.telNo)}
                  helperText={formik.touched.telNo && formik.errors.telNo}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="emlAddr"
                  name="emlAddr"
                  label="이메일"
                  value={formik.values.emlAddr}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.emlAddr && Boolean(formik.errors.emlAddr)
                  }
                  helperText={formik.touched.emlAddr && formik.errors.emlAddr}
                />
              </Grid>
              <Grid item xs={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko"
                >
                  <DatePicker
                    label="입사일"
                    format="YYYY-MM-DD"
                    mask={'____-__-__'}
                    id="entryDt"
                    name="entryDt"
                    value={dayjs(entryDt)}
                    onChange={(newValue) => {
                      setEntryDt(dayjs(newValue));
                      onChangeDate(dayjs(newValue), 'entryDt');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        error={
                          formik.touched.entryDt &&
                          Boolean(formik.errors.entryDt)
                        }
                        helperText={
                          formik.touched.entryDt && formik.errors.entryDt
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={3}>
                <HrPolicySelectbox
                  formik={formik}
                  name="policyUuid"
                  label="직책"
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
            
            </Grid>
            {/* <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={3}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="postAddrNm"
                  name="postAddrNm"
                  label="우편번호"
                  value={formik.values.postAddrNm}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.postAddrNm &&
                    Boolean(formik.errors.postAddrNm)
                  }
                  helperText={
                    formik.touched.postAddrNm && formik.errors.postAddrNm
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="postAddrTxt"
                  name="postAdtrTxt"
                  label="주소"
                  value={formik.values.postAddrTxt}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.postAddrTxt &&
                    Boolean(formik.errors.postAddrTxt)
                  }
                  helperText={
                    formik.touched.postAddrTxt && formik.errors.postAddrTxt
                  }
                />
              </Grid>
            </Grid> */}
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={9}>
                <Box sx={{ mt: 2 }}>
                  <Typography variant="subtitle2" component="div" sx={{ mb: 1 }}>
                    권한
                  </Typography>
                  <Stack
                    direction="row"
                    useFlexGap
                    sx={{ flexWrap: 'wrap', gap: 1 }}
                  >
                    {authCodeList.map((item) => {
                      const isChecked =
                        _.findIndex(
                          formik?.values?.privilegeList,
                          (checked) =>
                            checked?.authYn === 'Y' &&
                            checked.authTyp === item.revVal2,
                        ) !== -1;

                      return (
                        <Chip
                          key={item?.slcCd || item?.revVal2}
                          label={item?.revVal1}
                          size="small"
                          color={isChecked ? 'primary' : 'default'}
                          variant={isChecked ? 'filled' : 'outlined'}
                          onClick={() =>
                            handleChangePrivilege(item, !isChecked)
                          }
                        />
                      );
                    })}
                  </Stack>
                </Box>
              </Grid>
              <Grid item xs={3}>
                <FormGroup>
                  <FormControlLabel
                    id="useYn"
                    name="useYn"
                    label="사용"
                    control={
                      <Checkbox
                        checked={formik.values.useYn}
                        defaultChecked
                        onChange={(event) =>
                          formik.setFieldValue('useYn', event.target.checked)
                        }
                      />
                    }
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{ px: 1 }}
          >
            <Grid item xs={12}>
              <TextField
                margin="normal"
                variant="outlined"
                fullWidth
                id="infoDesc"
                name="infoDesc"
                label="참고사항"
                multiline
                rows={5}
                value={formik.values.infoDesc}
                onChange={formik.handleChange}
                error={
                  formik.touched.infoDesc && Boolean(formik.errors.infoDesc)
                }
                helperText={formik.touched.infoDesc && formik.errors.infoDesc}
              />
            </Grid>
          </Grid>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 1,
          }}
        >
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>
      </Paper>
    </>
  );
};

export default EmployeeForm;
